import React from "react";
import { Link } from "react-router-dom";
import * as CONFIG from "./_config";
import ls from "local-storage";

const axios = require("axios");

function PunchRewardDetailsModal({ value, reedemoptions }) {
    var MemberNumber = ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`)
        ? ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`).MemberNumber
        : "";

    console.log("value", value);
    return (
        <div class="modal" id="PunchRewardDetailsShowModal">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header" style={{ backgroundColor: "#f4f4f4" }}>
                        <h4 class="modal-title">REWARD DETAILS</h4>
                        <button type="button" class="close" data-dismiss="modal">
                            &times;
                        </button>
                    </div>

                    <div class="modal-body reward-detail-item" style={{ textAlign: "center" }}>
                        <h4 className="member-title" style={{ textAlign: "center" }}>
                            Member Number: {MemberNumber}
                        </h4>
                        <tr className="modal-reward">
                            <td>
                                <img
                                    src={value.ImageUrl}
                                    alt=""
                                    style={{
                                        width: "150px",
                                        height: "150px",
                                    }}
                                />
                            </td>
                        </tr>
                        <div className="punch-reward-detail-wrap">
                        <div className="modal-reward-title">
                            <h4>{value.Title}</h4>
                        </div>
                        {value?.RewardDetails || value?.ValidUPCs ? (
                            <div className="reward-desc-title">
                                <h2 className="punch-reward-title">Additional Details</h2>
                                <div className="reward-items-wrapper punch-reward">
                                    <p>{value.RewardDetails}</p>
                                    <p className="punch-reward-items-wrapper">{value.ValidUPCs}</p>
                                    {console.log(value.ValidUPCs)}
                                </div>
                            </div>
                        ) : ("")}
                        </div>
                    </div>

                    <div class="modal-footer" style={{
                        padding: "10px 16px"
                    }}>
                        <Link to="#" data-dismiss="modal">
                            <button
                                className={`btn btn-success ${CONFIG.DATA.CARDENAS_UI ? `cardenasmarkets-border-radius` : ``
                                    }`}
                                style={{
                                    backgroundColor: "#b30838 ",
                                    color: "white",
                                }}
                            >
                                Cancel
                            </button>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PunchRewardDetailsModal;
